/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type ItamAiInsightsPreviewEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line typescript/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const itamAiInsightsPreviewEntryPoint: EntryPoint<
	ItamAiInsightsPreviewEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<ItamAiInsightsPreviewEntryPointComponent>(
		/* eslint-disable-next-line @atlassian/react-entrypoint/entrypoint-root-module-path */
		/* webpackChunkName: "async-itam-ai-insights-preview-entrypoint", jiraSpaEntry: "async-itam-ai-insights-preview-entrypoint" */ './ItamAiInsightsPreviewPage.tsx',
	),
	getPreloadProps: (_entryPointRouteParams: EntryPointRouteParams) => {
		return {
			entryPoints: {},
		};
	},
});
